import VimeoServices from '@/services/vimeo'

export default function(vimeoParams) {
  const {
    vimeoBaseUrl,
    vimeoClientId,
    vimeoClientSecret,
    vimeoAccessToken,
  } = vimeoParams

  const missingParams =
    !vimeoBaseUrl || !vimeoClientId || !vimeoClientSecret || !vimeoAccessToken

  if (missingParams) {
    return null
  }

  return new VimeoServices(
    vimeoBaseUrl,
    vimeoClientId,
    vimeoClientSecret,
    vimeoAccessToken,
  )
}
